import { render, staticRenderFns } from "./AutomatedDeepLTranslations.vue?vue&type=template&id=0484fe30&scoped=true&"
import script from "./AutomatedDeepLTranslations.vue?vue&type=script&lang=js&"
export * from "./AutomatedDeepLTranslations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0484fe30",
  null
  
)

export default component.exports